export default __webpack_public_path__ + "static/media/121.90d3915b.gif";